import { useCallback, useEffect, useRef, useState } from "react";

export default function useDebounce(value, delay = 500, onDebounce) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const callbackRef = useRef(onDebounce);
    const isFirstRender = useRef(true);

    useEffect(() => {
        callbackRef.current = onDebounce;
    }, [onDebounce]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            setDebouncedValue(value);
            return;
        }

        const timer = setTimeout(() => {
            setDebouncedValue(value);
            if (typeof callbackRef.current === "function") {
                callbackRef.current(value);
            }
        }, delay);

        return () => clearTimeout(timer);
    }, [value, delay]);

    return debouncedValue;
}

export function useDebouncedCallback(fn, delay = 500) {
    const timer = useRef();

    return useCallback(
        (...args) => {
            clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                fn(...args);
            }, delay);
        },
        [fn, delay]
    );
}
